import * as React from "react";
const SvgCard = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={0.1}
      d="M22.193 4.045H1.937C.909 4.045.05 4.913.05 5.955v12.062c0 1.07.859 1.937 1.887 1.937h20.226c1.057 0 1.886-.868 1.886-1.907V5.956a1.87 1.87 0 0 0-1.856-1.911ZM.909 5.955c0-.58.457-1.042 1.031-1.042h20.226c.574 0 1.032.463 1.032 1.043v.982H.908zm22.315 12.088c0 .58-.457 1.043-1.031 1.043H1.937a1.03 1.03 0 0 1-1.032-1.043v-7.636H23.22v7.636zm0-8.5H.91V7.806h22.315z"
    />
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={0.1}
      d="M6.486 16.356h10.872c.2 0 .378.18.378.383a.39.39 0 0 1-.378.382H6.486a.393.393 0 0 1-.378-.382.39.39 0 0 1 .378-.383Z"
    />
    <path
      fill="currentColor"
      d="M3.624 17.46a.72.72 0 0 0 .717-.725.72.72 0 0 0-.717-.724.72.72 0 0 0-.716.724c0 .4.32.724.716.724"
    />
  </svg>
);
export default SvgCard;
